import { Component, Inject, Injector, Input, OnInit } from '@angular/core';
import { Healthcareservice } from 'app/core/interfaces/healthcareservice';
import  { OrganizationInterface } from 'app/core/interfaces/organization';
import { BaseComponent } from '../base.component';
import { OrganizationLocationService } from 'app/core/http/services/organization-location.service';
import { PatientScheduleRegistrationComponent } from 'app/modules/patient/pages/schedule/registration/schedule-registration.component';
import { ProcedureService } from 'app/core/http/services/procedure.service';
import { firstValueFrom } from 'rxjs';
import { MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';
import { DialogData } from 'app/core/interfaces/dialog';
import { ScheduleSelectPatientComponent } from '../schedule-select-patient/schedule-select-patient.component';
import { Location as LocationModel } from 'app/core/interfaces/location';


@Component({
  selector: 'schedule-organization-card',
  templateUrl: './schedule-organization-card.component.html',
  styleUrls: ['./schedule-organization-card.component.css']
})
export class ScheduleOrganizationCardComponent extends BaseComponent {

  @Input() healthcareservice !: Healthcareservice;
  @Input() location !: LocationModel;
  @Input() organization  ?: OrganizationInterface
  @Input() userLogged : any
  @Input() practitionerRole ?: any
  @Input() index: number = 0;

  @Input() dealer !: string;

  public healthcareService ?: Healthcareservice

  public selectedDatetime !: string;
  public patientLogged !: {
    user_id: string;
    name: string;
    email: string
  }

  @Input() actor !: 'SECRETARY' | 'PATIENT'
  public isByOrder: boolean = false
  

  constructor(
    private healthcareserviceService: ProcedureService,
    private locationService: OrganizationLocationService,
    public injector: Injector,
    @Inject(MAT_DIALOG_DATA) public data: DialogData,
    private dialogRef: MatDialogRef<ScheduleOrganizationCardComponent>
  )
   { 
    super(injector)
   }

  async ngOnInit() {

    const userLogged = this.getUserLogged();

    this.userLogged = {
      user_id: userLogged.id,
      name: userLogged.name,
      email: userLogged?.email,
      birthDate: userLogged.birthDate
    };

    if (this.data.param){

      this.organization = this.data.param.organization
      this.healthcareservice = this.data.param.procedure
      this.location = this.data.param.address
      this.dealer = this.data.param.dealer
      this.actor  = this.data.param?.actor
    }

    this.healthcareService = await this.getHealthcareService(this.healthcareservice.healthcareservice_id)
  }


  async getHealthcareService(healthcareservice_id: string): Promise<any> {
    return firstValueFrom(this.healthcareserviceService.show(healthcareservice_id));
  }

  getHealthcarePrice(healthcareservice : Healthcareservice) {
    if (!healthcareservice) return null;
    return `R$${healthcareservice?.price_high}`;
  }

  onSelectedDatetime(datetime: string, healthcareservice: any) {
    this.selectedDatetime = datetime;
    
    if (this.actor == 'SECRETARY') {
      this.openSelectPatientRegistrationForm(healthcareservice)
    } else {
      this.openEncounterRegistrationForm(healthcareservice);
    }

  }


  async openEncounterRegistrationForm(healthcareserviceSpecialist: any) {
    try {
      const healthcareServiceDetails =  this.healthcareService
      let practitioner = {}


      if (this.dealer == 'Organização'){
         practitioner = {
          name: this.organization?.name,
          practitioner_id: this.organization?.organization_id,
        };
      }else{
         practitioner = {
          name: healthcareserviceSpecialist.practitionername,
          practitioner_id: healthcareserviceSpecialist.practitioner_id,
        };
      }
     

      const procedureAdapter = {
        ...healthcareServiceDetails,
        healthcareservice_id: healthcareserviceSpecialist.healthcareservice_id,
        organization: {
          organization_id: this.organization?.organization_id,
          name: this.organization?.name,
        },
      };

      const data = {
        title: 'Agendar Procedimento',
        param: {
          procedure: procedureAdapter,
          type: procedureAdapter.type,
          address: this.location,
          patient: this.patientLogged,
          practitioner: practitioner,
          datetime: this.selectedDatetime,
        },
      };


      this.dialog.openComponentDialog(PatientScheduleRegistrationComponent, data, {
        width: '800px',
        height: '600px',
      })
      
    } catch (error) {
      console.error('Erro ao buscar fechar modal registration patient:', error);
    }
  }

  async openSelectPatientRegistrationForm(healthcareservice: any) {
      try {
        const healthcareServiceDetails = this.healthcareService
  
        let practitioner = {}

        if (this.dealer == 'Organização'){
          practitioner = {
            name: this.organization?.name,
            practitioner_id: this.organization?.organization_id,
          };
        }else{
           practitioner = {
            name: healthcareservice.practitionername,
            practitioner_id: healthcareservice.practitioner_id,
          };
        }
  
        const procedureAdapter = {
          ...healthcareServiceDetails,
          organization: {
            organization_id: healthcareservice.organization?.organization_id,
            name: healthcareservice.organization?.name,
          },
        };
  
  
        const data = {
          title: 'Agendar consulta',
          param: {
            procedure: procedureAdapter,
            type: procedureAdapter.type,
            address: this.location,
            secretary: this.userLogged,
            practitioner: practitioner,
            isByOrder: this.isByOrder,
            datetime: this.selectedDatetime
          },
        };

  

        this.dialog.openComponentDialog(ScheduleSelectPatientComponent, data, {
          width: '760px',
          maxWidth: '92vw',
          maxHeight: '90vh',
        }).subscribe((res: any) => {
          this.dialog.close()
  
        });
  
  
      } catch (error) {
        console.error('Erro ao buscar HealthcareService:', error);
      }
    }
  

}
